// extracted by mini-css-extract-plugin
module.exports = {"button":"PrimaryButton_button__3ac-1"};